import { render, staticRenderFns } from "./Settlement.vue?vue&type=template&id=c71d667a&scoped=true"
import script from "./Settlement.vue?vue&type=script&lang=js"
export * from "./Settlement.vue?vue&type=script&lang=js"
import style0 from "./Settlement.vue?vue&type=style&index=0&id=c71d667a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71d667a",
  null
  
)

export default component.exports